import useUpdate from "@taroify/hooks/use-force-update"

export default useUpdate
